import * as React from "react"
import { cn } from "@/lib/utils"

export interface LinkedInIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * LinkedIn icon as SVG
 *
 * This icon represents the LinkedIn professional network platform.
 *
 * @example
 * ```tsx
 * <LinkedInIcon />
 * <LinkedInIcon size={24} className="text-blue-600" />
 * ```
 */
export const LinkedInIcon = React.forwardRef<SVGSVGElement, LinkedInIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M16.6758 0H1.32031C0.589844 0 0 0.574219 0 1.28906V16.7109C0 17.4258 0.589844 18 1.32031 18H16.6758C17.4062 18 18 17.4258 18 16.7109V1.28906C18 0.574219 17.4062 0 16.6758 0ZM5.33203 15.3359H2.66797V6.74609H5.33203V15.3359ZM3.99609 5.58984C3.14062 5.58984 2.44922 4.89844 2.44922 4.04688C2.44922 3.19531 3.14062 2.50391 3.99609 2.50391C4.84766 2.50391 5.53906 3.19531 5.53906 4.04688C5.53906 4.89453 4.84766 5.58984 3.99609 5.58984ZM15.3359 15.3359H12.6758V11.1602C12.6758 10.1641 12.6562 8.88281 11.2812 8.88281C9.88672 8.88281 9.66797 9.97266 9.66797 11.0859V15.3359H7.00781V6.74609H9.55859V7.92188H9.59766C9.95703 7.24219 10.8398 6.52344 12.1406 6.52344C14.8359 6.52344 15.3359 8.30859 15.3359 10.6367V15.3359Z" />
      </svg>
    )
  }
)

LinkedInIcon.displayName = "LinkedInIcon"
